import * as React from 'react';
import {observer, inject} from 'mobx-react';
import {RouteComponentProps} from 'react-router';
import {FormComponentProps} from 'antd/lib/form/Form';
import {TeamDetailModelType} from '../../models/TeamDetailModel';
import Layout, {Main} from '../../components/Layout';
import Card, {CardHeader, CardBody} from '../../components/Card';
import {Helmet} from 'react-helmet';
import {Form, Input, Button, Icon, Upload, message, Modal} from 'antd';
import {getAccessToken} from '../../services/tokenPersistence';

const {TextArea} = Input;
// tslint:disable

const UPLOAD_ENDPOINT =
  (window as any).UPLOAD_ENDPOINT || process.env.REACT_APP_UPLOAD_ENDPOINT;

interface EditTeamFormProps
  extends FormComponentProps,
    RouteComponentProps<{teamId: string}> {
  teamDetail: TeamDetailModelType;
}

interface EditTeamFormState {
  fileList: any;
  previewVisible: boolean;
  previewImage: string;
}

@inject('teamDetail')
@observer
class EditTeamForm extends React.Component<
  EditTeamFormProps,
  EditTeamFormState
> {
  constructor(props: EditTeamFormProps) {
    super(props);
    this.state = {
      previewVisible: false,
      previewImage: '',
      fileList: []
    };
  }
  private get _withInjectedProps() {
    return this.props as EditTeamFormProps;
  }

  private get _teamId() {
    return Number(this._withInjectedProps.match.params.teamId);
  }

  async componentDidMount() {
    await this._withInjectedProps.teamDetail.getTeamDetail(this._teamId);
    const {team} = this._withInjectedProps.teamDetail;
    if (team) {
      this.setState({
        fileList: [
          {
            uid: '-1',
            name: 'image.png',
            status: 'done',
            url: team.avatar
          }
        ]
      });
    }
  }

  renderLoading() {
    return (
      <div style={{margin: 'auto'}}>
        <Button shape="circle" loading={true} />
      </div>
    );
  }

  handleSubmit = (e: any) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) {
        return;
      }
      this._withInjectedProps.teamDetail.updateTeamInfo(this._teamId, values);
    });
  };

  getUploadEndpoint() {
    return `${UPLOAD_ENDPOINT}/pictures/team`;
  }

  handleCancel = () => this.setState({previewVisible: false});

  getBase64(file: any) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        if (reader.result) {
          resolve(reader.result);
        }
      };
      reader.onerror = error => reject(error);
    });
  }

  handlePreview = async (file: any) => {
    if (!file.url && !file.preview) {
      file.preview = await this.getBase64(file.originFileObj);
    }

    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true
    });
  };

  handleChange = ({fileList, file}: any) => {
    this.setState({fileList});

    if (file.status === 'done') {
      const {setFieldsValue} = this.props.form;
      const url = file.response.url;
      if (!url) {
        message.error('Upload image failure');
        return;
      }
      this.setState({
        fileList: [
          {
            uid: file.uid,
            name: file.name,
            status: 'done',
            url: url
          }
        ]
      });

      setFieldsValue({avatar: url});
    }
  };

  renderUploadButton() {
    const {previewVisible, previewImage, fileList} = this.state;
    const token = getAccessToken();
    const uploadButton = (
      <Button>
        <Icon type="upload" /> Change
      </Button>
    );
    return (
      <React.Fragment>
        <Upload
          action={this.getUploadEndpoint()}
          listType="picture-card"
          fileList={fileList}
          onPreview={this.handlePreview}
          onChange={this.handleChange}
          headers={{Authorization: `Bearer ${token}`}}
        >
          {uploadButton}
        </Upload>
        <Modal
          visible={previewVisible}
          footer={null}
          onCancel={this.handleCancel}
        >
          <img alt="example" style={{width: '100%'}} src={previewImage} />
        </Modal>
      </React.Fragment>
    );
  }

  renderFormEdit() {
    const {getFieldDecorator} = this.props.form;
    const {team} = this._withInjectedProps.teamDetail;
    const formItemLayout = {
      labelCol: {
        xs: {span: 24},
        sm: {span: 4}
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 20}
      }
    };

    if (!team) {
      return null;
    }

    return (
      <Form layout="vertical" onSubmit={this.handleSubmit}>
        <Form.Item {...formItemLayout} label="Avatar">
          {getFieldDecorator('avatar', {
            initialValue: team.avatar,
            rules: []
          })(this.renderUploadButton())}
        </Form.Item>

        <Form.Item {...formItemLayout} label="Team Name">
          {getFieldDecorator('name', {
            initialValue: team.name,
            rules: [
              {
                required: true,
                message: 'Team name is required'
              }
            ]
          })(<Input />)}
        </Form.Item>

        <Form.Item {...formItemLayout} label="About">
          {getFieldDecorator('about', {
            initialValue: team.about,
            rules: []
          })(<TextArea rows={8} />)}
        </Form.Item>

        <Form.Item {...formItemLayout}>
          <Button type="primary" htmlType="submit">
            Save
          </Button>
        </Form.Item>
      </Form>
    );
  }
  render() {
    const {isLoading} = this._withInjectedProps.teamDetail;
    return (
      <React.Fragment>
        <Helmet>
          <title>Team Edit</title>
        </Helmet>
        <Layout>
          <Main>
            <Card>
              <CardHeader>Team Edit</CardHeader>
              <CardBody>
                {isLoading ? this.renderLoading() : this.renderFormEdit()}
              </CardBody>
            </Card>
          </Main>
        </Layout>
      </React.Fragment>
    );
  }
}

const EditTeam = Form.create()(EditTeamForm);
export default EditTeam;



// WEBPACK FOOTER //
// ./src/pages/EditTeam/EditTeam.tsx